import React, { useContext, useEffect, Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Nav, Navbar, Row, Col } from 'react-bootstrap';
import { navbarBreakPoint, topNavbarBreakpoint } from 'config';
import AppContext from 'context/Context';
import Flex from 'components/common/Flex';
import Logo from 'components/common/Logo';
import NavbarVerticalMenu from './NavbarVerticalMenu';
import ToggleButton from './ToggleButton';
import { appRoutes } from 'routes/routes';
import NavbarTopDropDownMenus from 'components/navbar/top/NavbarTopDropDownMenus';
import bgNavbar from 'assets/img/generic/bg-navbar.png';

const NavbarVertical = ({
  monitoringLocationData,
  blockLocationData,
  firstEvaluationCluster,
  firstMonitoringCluster,
  firstBlockCluster
}) => {
  const {
    config: {
      navbarPosition,
      navbarStyle,
      isNavbarVerticalCollapsed,
      showBurgerMenu
    }
  } = useContext(AppContext);

  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  const [routes, setRoutes] = useState([]);

  useEffect(() => {
    if (isNavbarVerticalCollapsed) {
      HTMLClassList.add('navbar-vertical-collapsed');
    } else {
      HTMLClassList.remove('navbar-vertical-collapsed');
    }
    return () => {
      HTMLClassList.remove('navbar-vertical-collapsed-hover');
    };
  }, [isNavbarVerticalCollapsed, HTMLClassList]);

  //Control mouseEnter event
  let time = null;
  const handleMouseEnter = () => {
    if (isNavbarVerticalCollapsed) {
      time = setTimeout(() => {
        HTMLClassList.add('navbar-vertical-collapsed-hover');
      }, 100);
    }
  };
  const handleMouseLeave = () => {
    clearTimeout(time);
    HTMLClassList.remove('navbar-vertical-collapsed-hover');
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const routesData = await appRoutes;
        setRoutes(routesData);
      } catch (error) {
        console.error('Error fetching routes:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <Navbar
      expand={navbarBreakPoint}
      className={classNames('navbar-vertical', {
        [`navbar-${navbarStyle}`]: navbarStyle !== 'transparent'
      })}
      variant="light"
    >
      <Flex alignItems="center">
        <ToggleButton />
        <Logo
          at="navbar-vertical"
          width={40}
          monitoringLocationData={monitoringLocationData}
          firstMonitoringCluster={firstMonitoringCluster}
        />
      </Flex>
      <Navbar.Collapse
        in={showBurgerMenu}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{
          backgroundImage:
            navbarStyle === 'vibrant'
              ? `linear-gradient(-45deg, rgba(0, 160, 255, 0.86), #0048a2),url(${bgNavbar})`
              : 'none'
        }}
      >
        <div className="navbar-vertical-content scrollbar">
          <Nav className="flex-column" as="ul">
            {routes?.map(route => (
              <Fragment key={route?.label}>
                <NavbarVerticalMenu
                  routes={route?.children}
                  monitoringLocationData={monitoringLocationData}
                  blockLocationData={blockLocationData}
                  firstEvaluationCluster={firstEvaluationCluster}
                  firstMonitoringCluster={firstMonitoringCluster}
                  firstBlockCluster={firstBlockCluster}
                />
              </Fragment>
            ))}
          </Nav>

          <>
            {navbarPosition === 'combo' && (
              <div className={`d-${topNavbarBreakpoint}-none`}>
                <div className="navbar-vertical-divider">
                  <hr className="navbar-vertical-hr my-2" />
                </div>
                <Nav navbar>
                  <NavbarTopDropDownMenus />
                </Nav>
              </div>
            )}
          </>
        </div>
      </Navbar.Collapse>
    </Navbar>
  );
};

NavbarVertical.propTypes = {
  firstEvaluationCluster: PropTypes.string,
  firstMonitoringCluster: PropTypes.string,
  firstBlockCluster: PropTypes.string,
  monitoringLocationData: PropTypes.arrayOf(PropTypes.object),
  blockLocationData: PropTypes.arrayOf(PropTypes.object)
};

export default NavbarVertical;
